// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"dc028fdc","479":"5cc127ff","480":"2e42da7b","490":"4f473f80","834":"c571e8e5"}[chunkId] + ".chunk.js";
};